import { IsDefined, IsHexColor } from 'class-validator';
import { field } from '../../fields';
import { BrandId, FragranceId, PromotionBestsellerId, PromotionNewbieId, PromotionOfferId, StoreOfferId } from '../id';

abstract class PromotionFragranceBaseDto {
	@FragranceId()
	fragranceId!: FragranceId;

	@field.Number({ int: true, min: 1, max: 5 })
	order!: number;
}

export class PromotionOfferDto extends PromotionFragranceBaseDto {
	@PromotionOfferId({ optional: true })
	id?: PromotionOfferId;

	@StoreOfferId({ optional: true })
	storeOfferId?: StoreOfferId;
}

export class PromotionBestsellerDto extends PromotionFragranceBaseDto {
	@PromotionBestsellerId({ optional: true })
	id?: PromotionBestsellerId;
}

export class PromotionNewbieDto extends PromotionFragranceBaseDto {
	@PromotionNewbieId({ optional: true })
	id?: PromotionNewbieId;
}

export class PromotionUpdateDto {
	@field.String({ optional: true })
	description?: string;

	@IsDefined()
	@field.String()
	logo!: string;

	@IsDefined()
	@field.String()
	logoDark!: string;

	@field.String({ array: true, optional: true })
	@IsHexColor({ each: true })
	brandColors?: string[];

	@field.String({ optional: true })
	bannerImage?: string;

	@field.DateTime({})
	activeFrom!: Date;

	@field.DateTime({})
	activeTo!: Date;

	@field.Obj(PromotionOfferDto, { array: true })
	offers: PromotionOfferDto[] = [];

	@field.Obj(PromotionBestsellerDto, { array: true })
	bestsellers: PromotionBestsellerDto[] = [];

	@field.Obj(PromotionNewbieDto, { array: true })
	newbies: PromotionNewbieDto[] = [];
}

export class PromotionCreateDto extends PromotionUpdateDto {
	@BrandId()
	brandId!: BrandId;
}
